import { useState } from 'react';
import { useHoldDeadline } from '../../../lib/use-hold-deadline';
import { useActivityMapViewSwitchDecided } from '../../../lib/activity-map-view-switch';
import { Home3Body, HOME3_PAGE } from '../home3';
import { useOnboardingEntry } from '../../../lib/use-onboarding-entry';
import { useHomeShowsGoalPicker } from '../../../lib/use-home-goal-picker';
import { DashboardPane } from './DashboardPane';
import { EmptyDashboard } from './EmptyDashboard';
import { DashboardLoading } from './DashboardLoading';

export function DashboardView() {
  // Whether the home is showing its full-bleed canvas (the map view, on the desktop). The view is that
  // screen's own local state, so it reports here and the pane drops its padding and scroll.
  const [canvas, setCanvas] = useState(false);
  // A brand-new user would see the home for the beat before the DERIVED onboarding kickoff opens the chat over
  // it — the flicker native suppresses with `onboardingKickoffActive` — so the loader holds until the onboarding
  // decision resolves. A read that never settles is not an error and never becomes one, so the hold is capped:
  // past the cap, show what we have — a screen the user can act on beats a spinner.
  const { resolved: onboardingResolved } = useOnboardingEntry();
  const holdExpired = useHoldDeadline(!onboardingResolved);
  // The goal picker shows until the user has FINISHED ONBOARDING, then the home — the same rule as iOS and
  // Android (`lib/home-goal-picker.ts`). An unknown answer shows the home.
  const showsGoalPicker = useHomeShowsGoalPicker();
  // Mounting the home before the view-switch answer would show the task list and then grow a switch under the
  // reader. The gate caps itself, so this resolves to control rather than spinning.
  const viewSwitchDecided = useActivityMapViewSwitchDecided();

  if (!viewSwitchDecided) return <DashboardLoading pane />;
  if (!onboardingResolved && !holdExpired) return <DashboardLoading pane />;
  if (showsGoalPicker)
    return (
      <DashboardPane bare>
        <EmptyDashboard page={HOME3_PAGE} />
      </DashboardPane>
    );

  // The 900px floor still applies — below it the page scrolls sideways instead of squeezing its cards.
  return (
    <DashboardPane scroll tightTop canvas={canvas}>
      <Home3Body onCanvasChange={setCanvas} />
    </DashboardPane>
  );
}
